/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/registry 层；
 * 2. 负责注册默认启用的特征 mesh 对象工厂组合；
 * 3. 该文件属于装配根，不承担具体对象构造逻辑。
 *
 * 文件职责：
 * 1. 注册默认启用的特征 mesh 对象工厂；
 * 2. 把 MeshManager 与具体工厂列表解耦；
 * 3. 为后续新增特征提供集中装配入口。
 */

import { ExtrudeMeshObjectFactory } from '../factory/ExtrudeMeshObjectFactory';
import { BossRevolveMeshObjectFactory } from '../factory/BossRevolveMeshObjectFactory';
import { ChamferMeshObjectFactory } from '../factory/ChamferMeshObjectFactory';
import { FeatureMeshObjectFactoryRegistry } from '../factory/FeatureMeshObjectFactoryRegistry';
import { FilletMeshObjectFactory } from '../factory/FilletMeshObjectFactory';
import { RibMeshObjectFactory } from '../factory/RibMeshObjectFactory';
import { ShellMeshObjectFactory } from '../factory/ShellMeshObjectFactory';

/**
 * 默认特征 mesh 对象工厂注册表实例。
 */
export const defaultFeatureMeshObjectFactoryRegistry = new FeatureMeshObjectFactoryRegistry()
  .registerMany([
    new ChamferMeshObjectFactory(),
    new ExtrudeMeshObjectFactory(),
    new FilletMeshObjectFactory(),
    new BossRevolveMeshObjectFactory(),
    new ShellMeshObjectFactory(),
    new RibMeshObjectFactory(),
  ]);
